var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-navigation-drawer",
    {
      attrs: { app: "", dark: "", right: "" },
      scopedSlots: _vm._u([
        {
          key: "append",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "pa-2" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "tesfriRaspberry", block: "" },
                      on: { click: _vm.handleLogout }
                    },
                    [_vm._v("Déconnexion")]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ]),
      model: {
        value: _vm.drawer,
        callback: function($$v) {
          _vm.drawer = $$v
        },
        expression: "drawer"
      }
    },
    [
      _c(
        "v-list",
        { attrs: { dense: "", flat: "", nav: "" } },
        [
          _c(
            "v-list-item",
            [
              _c("v-list-item-title", [
                _vm._v(
                  _vm._s(
                    _vm.code +
                      " - " +
                      _vm.currentCompany +
                      " - " +
                      _vm.currentWarehouse
                  )
                )
              ])
            ],
            1
          ),
          _c(
            "v-list-item",
            { attrs: { to: "/Profile" } },
            [
              _c(
                "v-list-item-action",
                [_c("v-icon", [_vm._v("far fa-user")])],
                1
              ),
              _c("v-list-item-title", [_vm._v("Profil")])
            ],
            1
          ),
          _vm._l(_vm.companies, function(company, index) {
            return _c(
              "v-list-group",
              {
                key: company + "-" + index,
                attrs: {
                  "active-class": "tesfriRaspberry--text",
                  "no-action": ""
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "activator",
                      fn: function() {
                        return [
                          _c("v-list-item-title", [
                            _vm._v(_vm._s(company.code))
                          ])
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  true
                )
              },
              _vm._l(company.warehouses, function(warehouse, index) {
                return _c(
                  "v-list-item",
                  {
                    key: warehouse.code + "-" + index,
                    on: {
                      click: function($event) {
                        _vm
                          .updateCurrentCompanyWarehouse({
                            companyCode: company.code,
                            warehouseCode: warehouse.code
                          })
                          .then(function(d) {
                            return _vm.redirectToHome()
                          })
                      }
                    }
                  },
                  [
                    _c("v-list-item-title", {
                      domProps: { textContent: _vm._s(warehouse.code) }
                    })
                  ],
                  1
                )
              }),
              1
            )
          })
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }